export const environment = {
    webappsRootURL: 'https://project2apps.epa.ohio.gov',
    ebizRootURL: 'https://epaproject2apps.epa.ohio.gov',
    clientID: '478ab68d-8027-4f91-bff8-630c800fe082',
    redirectURI: 'https://gwqcp.project2.epa.ohio.gov/'
};
